import OPTInput from "./OPTInput";

export { OPTInput };

export default OPTInput;
